import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "MEMBER_UPDATE_ERROR":
            return action.error;

        case "MEMBER_UPDATE_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "MEMBER_UPDATE_LOADING":
            return action.loading;

        case "MEMBER_UPDATE_RESET":
            return false;

        default:
            return state;
    }
}

export function updated(state = null, action) {
    switch (action.type) {
        case "MEMBER_UPDATE_SUCCESS":
            return action.success;

        case "MEMBER_UPDATE_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({updated, loading, error});
